module.exports = __webpack_public_path__ + "b5a25a36a05db765fb6926c9b9600ddb.png";


//////////////////
// WEBPACK FOOTER
// ./content/help/research/insilico/scoring-img/img13.png
// module id = 1319
// module chunks = 0